import { ReturnExchangeDownloadFormsApi } from "../../../../apis/ReturnExchangeDownloadFormsApi";
import { useApiInfoContextValueHook } from "../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../utils/sellertool-signature-utils";
import { useReturnExchangeDownloadFormsActionsContextHook } from "../contexts/ReturnExchangeDownloadFormsContext";

export function useFetcher(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const returnExchangeDownloadFormsActionsContextHook = useReturnExchangeDownloadFormsActionsContextHook();

    const fetchReturnExchangeDownloadForms = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const response = await ReturnExchangeDownloadFormsApi().searchList({ headers: headers });
        if (response?.content) {
            returnExchangeDownloadFormsActionsContextHook.returnExchangeDownloadForms.onSet(response.content);
        }
    }

    return {
        fetchReturnExchangeDownloadForms
    }
}